import React from "react";
import { Route, Switch } from "react-router-dom";
import Home from "./containers/Home";
import Aboutus from "./containers/Aboutus";
import Contactus from "./containers/Contactus";
import Gallery from "./containers/Gallery";
import Retnet2018 from "./containers/Retnet2018";
import RetnetSchedule from "./containers/RetnetSchedule";
import NotFound from "./containers/Notfound";
import Login from "./containers/Login";
import Signup from "./containers/Signup";
import NewBlog from "./containers/NewBlog";
import UserHome from "./containers/UserHome";
import EditProfile from "./containers/EditProfile";
import PersonalProfile from "./containers/PersonalProfile";
import ForgotPassword from "./containers/ForgotPassword";
import Confirmation from "./containers/Confirmation";
import DoctorsList from "./containers/DoctorsList";
import BookingDetails from "./containers/BookingDetails";
import RetnetRegistrations from "./containers/RetnetRegistrations";

import AppliedRoute from "./components/AppliedRoute";


export default ({ childProps }) =>
  <Switch>
    <AppliedRoute path="/" exact component={ Home } props={childProps} props={childProps}  />
    <AppliedRoute path="/register4retnet" exact component={ Home } props={childProps}  />
      <AppliedRoute path="/preconference" exact component={ Home } props={childProps}  />
      <AppliedRoute path="/conference" exact component={ Home } props={childProps}   />
    <AppliedRoute path="/retnetlive" exact component={ Home } props={childProps}   />
    <AppliedRoute path="/singleroom" exact component={ Home } props={childProps}   />
      <AppliedRoute path="/singleroom2nights" exact component={ Home } props={childProps}   />
    <AppliedRoute path="/doubleroom" exact component={ Home } props={childProps}   />
      <AppliedRoute path="/doubleroom2nights" exact component={ Home } props={childProps}   />
    <AppliedRoute path="/tripleroom" exact component={ Home } props={childProps}   />
    <AppliedRoute path="/thankyoupage" exact component={ Home } props={childProps}   />
    <AppliedRoute path="/aboutus" exact component= { Aboutus } props={childProps} />
    <AppliedRoute path="/contactus" exact component= { Contactus } props={childProps} />
    <AppliedRoute path="/gallery" exact component= { Gallery } props={childProps} />
    <AppliedRoute path="/retnet2026" exact component= { Retnet2018 } props={childProps} />
      <AppliedRoute path="/retnet-schedule" exact component= { RetnetSchedule } props={childProps} />
    <AppliedRoute path="/submitpresentation" exact component= { Home } props={childProps} />
    <AppliedRoute path="/retnetregistrations" exact component= { RetnetRegistrations } props={childProps} />

    <AppliedRoute path="/bookingconfirmation" exact component= { Home } props={childProps} />
    <AppliedRoute path="/login" exact component={Home} props={childProps}  />
    <AppliedRoute path="/forgotpassword" exact component={Home} props={childProps}  />
    <AppliedRoute path="/signup" exact component = {Home} props={childProps} />
    <AppliedRoute path="/blogs/new" exact component={ NewBlog } props= {childProps} />
    <AppliedRoute path="/blogs" exact component={ UserHome } props= {childProps} />
    <AppliedRoute path="/profile/edit" exact component={ EditProfile } props= {childProps} />
    <AppliedRoute path="/profile/edit2" exact component={ PersonalProfile } props= {childProps} />
    <AppliedRoute path="/doctors" exact component={ DoctorsList } props={childProps}  />

    <Route component = { NotFound } />
  </Switch>;



// WEBPACK FOOTER //
// ./src/Routes.js